import { render } from "./CreateProject.vue?vue&type=template&id=9ea84726"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Projects/CreateProject.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ea84726"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ea84726', __exports__)) {
    api.reload('9ea84726', __exports__)
  }
  
  module.hot.accept("./CreateProject.vue?vue&type=template&id=9ea84726", () => {
    api.rerender('9ea84726', render)
  })

}


export default __exports__